export default __webpack_public_path__ + "static/media/8.bc68984e.jpg";